<template>
    <v-sheet v-if="attachments.length">
        <h5 class="page-text page-text--lg mb-8 mb-lg-16">첨부파일</h5>
        <p class="page-text line-height-15">
            <v-chip-group>
                <template v-for="item in attachments">
                    <v-chip :key="item._id" :href="item.url" download large label outlined>
                        <v-icon small class="mr-4 ml-n2">mdi-file-outline</v-icon>
                        {{ item.name }}
                    </v-chip>
                </template>
            </v-chip-group>
        </p>
    </v-sheet>
</template>

<script>
import { initRecruitment } from "@/assets/variables";
export default {
    props: {
        recruitment: { type: Object, default: initRecruitment },
    },
    computed: {
        attachments() {
            return this.recruitment?.attachments;
        },
    },
};
</script>

<style></style>
